export const getContext = (state) => state.characterEnv.context;
export const getLoadingStatus = (state) => state.characterEnv.loadingStatus;
